import { DefaultUrlSerializer, Routes, UrlTree } from '@angular/router';
import { PageNotFoundComponent } from 'i2g-ng-ui';
import { AppGuard } from './guards';

export const ROUTES: Routes = [
  {
    path: '**',
    canActivate: [AppGuard],
    component: PageNotFoundComponent,
    data: {
      ctaRoute: ['/register'],
    },
  },
];

export class LowerCaseUrlSerializer extends DefaultUrlSerializer {
  parse(url: string): UrlTree {
    if (url && url.includes('?')) {
      const urlTokens = url.split('?');

      urlTokens[0] = urlTokens[0].toLowerCase();

      return super.parse(urlTokens.join('?'));
    }

    return super.parse(url.toLowerCase());
  }
}
